var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-area',{attrs:{"no-margin-top":"","title":"Testes rápidos"}},[_c('rkm-row',[_c('rkm-col',{attrs:{"cols":"12"}},[_c('Item',{attrs:{"get-value":() => _vm.item.plano.testesRapidos.join(', ')}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }